var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconMapPinLocationFilled = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.448 22.55c2.009-2.514 6.59-8.608 6.59-12.03A7.521 7.521 0 0 0 12.52 3 7.521 7.521 0 0 0 5 10.52c0 3.422 4.582 9.516 6.591 12.03.482.6 1.375.6 1.857 0zm-.929-14.537a2.506 2.506 0 1 1 0 5.013 2.506 2.506 0 0 1 0-5.013z",
    fill: "#3E704B",
    fillRule: "evenodd"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMapPinLocationFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-map-pin-location-filled.e80a8df0.svg";
export { ForwardRef as ReactComponent };